import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import DeviceLogPage from '../components/DeviceLogPage';

class DeviceLogOfAgent extends Component {
  constructor(props) {
    super(props)
    this.deviceId = decodeURIComponent(this.props.match.params.deviceId)
  }

  render() {
    const pageProps = {
      fetchLogs: (params, callback) => {
        DataFetcher.deviceLogs(
          {
            ...params,
            deviceId: this.deviceId
          }, 
          {
            success: callback
          }
        )
      }
    }

    return <DeviceLogPage {...pageProps}/>
  }
}

export default DeviceLogOfAgent;


// WEBPACK FOOTER //
// ./src/modules/DeviceLogOfAgent.js